// Compatibility API retained for callers; one canonical accessible dialog renderer.
import { Dialog } from '../ui';
import { Children, isValidElement, cloneElement } from 'react';
function headingIn(children) {
  let heading = null;
  Children.forEach(children, child => {
    if (heading || !isValidElement(child)) return;
    heading = typeof child.type === 'string' && /^h[1-4]$/.test(child.type)
      ? child : headingIn(child.props.children);
  });
  return heading;
}
function withoutHeading(children, heading) {
  return Children.map(children, child => child === heading ? null : isValidElement(child) && child.props.children
    ? cloneElement(child, {}, withoutHeading(child.props.children, heading)) : child);
}
export default function Modal({ children, onClose, isOpen, title, description, maxWidth, size }) {
  const heading = headingIn(children);
  return <Dialog open={Boolean(isOpen)} title={heading?.props.children || title || 'Details'} description={description}
    size={size === 'lg' || /[3-7]xl/.test(maxWidth || '') ? 'wide' : 'standard'}
    closeOnBackdrop cancelDisabled={!onClose} onCancel={() => onClose?.()}>{heading ? withoutHeading(children, heading) : children}</Dialog>;
}
